import styled from "@emotion/styled";
import React from "react";

interface SpacerProps {
  as?: "div" | "span";
  height?: number | string;
  width?: number | string;
  minHeight?: number | string;
  minWidth?: number | string;
}

export const Spacer = ({
  as = "div",
  height: heightRaw,
  width: widthRaw,
  minHeight: minHeightRaw,
  minWidth: minWidthRaw,
}: SpacerProps) => {
  const height = typeof heightRaw === "number" ? `${heightRaw}px` : heightRaw;
  const width = typeof widthRaw === "number" ? `${widthRaw}px` : widthRaw;
  const minHeight = typeof minHeightRaw === "number" ? `${minHeightRaw}px` : minHeightRaw;
  const minWidth = typeof minWidthRaw === "number" ? `${minWidthRaw}px` : minWidthRaw;

  return React.createElement(
    styled(as)(() => {
      return {
        height,
        width,
        minHeight,
        minWidth,
        ...(as === "span" ? { display: "inline-block" } : {}),
      };
    })
  );
};
